import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h1>Coming soon inventory</h1>
        </div>
    );
};

export default Inventory;